import { render } from "./LKFSelect.vue?vue&type=template&id=8182b258&ts=true"
import script from "./LKFSelect.vue?vue&type=script&lang=ts"
export * from "./LKFSelect.vue?vue&type=script&lang=ts"

import "./LKFSelect.vue?vue&type=style&index=0&id=8182b258&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__